import http from "@/BaseServiceHttp";

class DeviceService {
  getDevices(factoryId) {
    return http.get(`/factories/${factoryId}/devices`);
  }
  getWiFiSignalStrength(factoryId, startDate, endDate) {
    return http.get(`/factories/${factoryId}/devices/wifi-signal-strength?startDate=${startDate}&endDate=${endDate}`);
  }
  isManualRejectEntryDataSource(dataSource) {
    if (dataSource) {
      return dataSource.role === "reject" && dataSource.id === "reject-01"; // Data source ID `reject-01` means `Manual Reject Entry form`. (Should use device.type = manual)
    }
    return false;
  }
  isQuantityContributor(dataSource) {
    return !!dataSource.is_quantity_contributor;
  }
  getNetworkInfo(deviceId) {
    return http.get(`devices/${deviceId}/network`);
  }
}

export default new DeviceService();
